module.exports = __webpack_public_path__ + "media/images/other-images/boxbg-57cb7e691ff2185a623286c70403b579.jpg";